import eventBus from '../../../../services/eventBus'
import { IMaintenanceBlankSchema, IMaintenanceProcess } from '../maintenance.types.ts'

const schemaCreated = (item: IMaintenanceBlankSchema) => {
  eventBus.pub('maintenance.schemas.created', item)
}

const schemaUpdated = (item: IMaintenanceBlankSchema) => {
  eventBus.pub('maintenance.schemas.updated', item)
}

const schemaDeleted = (id: IMaintenanceBlankSchema['id']) => {
  eventBus.pub('maintenance.schemas.deleted', id)
}

const processCreated = (item: IMaintenanceProcess) => {
  eventBus.pub('maintenance.processes.created', item)
}

const processUpdated = (item: IMaintenanceProcess) => {
  eventBus.pub('maintenance.processes.updated', item)
}

const processDeleted = (id: IMaintenanceProcess['id']) => {
  eventBus.pub('maintenance.processes.deleted', id)
}

const maintenanceEvents = {
  schemaCreated,
  schemaUpdated,
  schemaDeleted,
  processCreated,
  processUpdated,
  processDeleted,
}
export default maintenanceEvents
